import * as React from 'react';
import { Table } from "soprasteria-ui-library";
import { IPreventionProgramPatient } from "../../../models/IPreventionProgramPatient"
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { dateTimeToDateString } from '../../../helpers/DateHelper';

interface IPreventionProgramInfantsTable {
    preventionProgramInfants: IPreventionProgramPatient[] | undefined;
}

export const PreventionProgramInfantsTable: React.FunctionComponent<IPreventionProgramInfantsTable> = ({ preventionProgramInfants }) => {

    return (
        <section >
            {
                preventionProgramInfants
                    ? <Table>
                        <thead>
                            <tr>
                                <th>Personnummer</th>
                                <th>Namn</th>
                                <th>Adress</th>
                                <th>Postadress</th>
                                <th>Vårdbehovsområde</th>
                                <th>Senaste ändring</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                preventionProgramInfants.length > 0
                                    ? preventionProgramInfants.map((patient, key) => {
                                        return (
                                            <tr key={key} >
                                                <td>{formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityId)}</td>
                                                <td>{patient.name}</td>
                                                <td>{patient.address}</td>
                                                <td>{patient.cityCode}</td>
                                                <td>{patient.careNeedArea}</td>
                                                <td>{dateTimeToDateString(patient.updDate)}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr><td colSpan={6}>Det finns inga poster att visa</td></tr>
                            }
                        </tbody>
                    </Table>
                    : null
            }
        </section>
    )
}